import React, { useRef, useContext } from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { useCookies } from 'react-cookie'

import useLockBodyScroll from '../../../utils/hooks/useLockBodyScroll'
import { GeolocalizationContext } from '../../../utils/contexts/geolocalization-context'
import { getPageURL } from '../../../utils/helpers/page-url'
import { lockAgeGate } from '../../../utils/helpers/age-lock'
import Image from '../../parts/image'

const AgeGateCero = ({ content, locked, lockCookieName }) => {
  const form = useRef(null)
  const { legalAge, ageGate, rating, formSubmit, currentLegalAge } = useContext(GeolocalizationContext)
  const [ageGateSettings, setAgeGateSettings] = ageGate
  const [gameRating, setGameRating] = rating
  const [countryLegalAge, setCountryLegalAge] = currentLegalAge
  const [formSubmitted, setFormSubmitted] = formSubmit
  const [isLegalAge, setLegalAge] = legalAge
  const [cookies, setCookie] = useCookies()
  let logo = content.logo ? content.logo : null
  const cookieName = content.cookieName

  useLockBodyScroll(form.current)

  // Enter - Legal Age
  const enterLegal = e => {
    e.preventDefault()
    setLegalAge(true)
    setAgeGateSettings(prev => ({ ...prev, displayed: false, usage: null }))
    setFormSubmitted(true)
    // And add a cookie to keep it closed
    const currentDomain = `${getPageURL('domain')}`
    setCookie(cookieName, true, { domain: `${currentDomain}`, path: '/' })
  }

  // Leave - Not Legal Age
  const leaveLegal = e => {
    e.preventDefault()
    lockAgeGate(ageGateSettings, lockCookieName)
    setLegalAge(false)
    setFormSubmitted(true)
  }

  return (
    <>
      <div ref={form} className="flex items-center flex-col">
        {logo !== null && (
          <Image
            media={logo}
            className={`age-gate-logo mb-12`}
          />
        )}
        <div className="age-gate-subtitle">
          <span>年齢認証</span>
        </div>
        <div className="text-white text-center text-base font-body font-bold tracking-wide">
          <p>このゲームは暴力的な表現が含まれています。</p>
          <p className="mt-2 mb-6">本サイトへのご入場は、ソフトの購入が可能な18歳以上の方に限定しております。</p>

          {!locked && (
            <>
              <p className="mb-12">あなたは{countryLegalAge ? countryLegalAge : '18'}歳以上ですか？</p>
              <div className="space-x-20 mb-16">
                <button className="age-gate-button button button-primary" onClick={enterLegal}>
                  <span><strong>はい</strong> {countryLegalAge ? countryLegalAge : '18'}歳以上です。</span>
                </button>
                <button className="age-gate-button button button-primary" onClick={leaveLegal}>
                  <span><strong>いいえ</strong> {countryLegalAge ? countryLegalAge : '18'}歳未満です。</span>
                </button>
              </div>
              <div className="flex justify-start">
                <a
                  href="https://www.cero.gr.jp/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {gameRating.logo ? (
                    <Image
                      media={gameRating.logo}
                      className={`w-24 h-auto`}
                      keepStyle={true}
                    />
                  ) : (
                    <StaticImage
                      src="../../../assets/img/ratings/cero/cero-z-text.png"
                      alt="CERO Z"
                      className="w-48"
                      loading="lazy"
                    />
                  )}
                </a>
              </div>
            </>
          )}
        </div>
      </div>
      <div className="age-gate-decoration-left" />
      <div className="age-gate-decoration-right" />
      <div className="age-gate-decoration-background" />
    </>
  )
}
export default AgeGateCero
